<template><section><template>
<h3>标签页</h3>
<div class="bs-docs-section">
<div class="bs-example">
<blockquote>
<p>使用list</p>
</blockquote>
<p><n3-tabs @change="change" :list="list"></n3-tabs></p>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-tabs</span> <span class="hljs-attr">@change</span>=<span class="hljs-string">"change"</span> <span class="hljs-attr">:list</span>=<span class="hljs-string">"list"</span>&gt;</span><span class="hljs-tag">&lt;/<span class="hljs-name">n3-tabs</span>&gt;</span>
</code></pre>
<pre v-pre=""><code v-pre="" class="language-javascript">data () {
  <span class="hljs-keyword">return</span> {
    <span class="hljs-attr">list</span>: [{
      <span class="hljs-attr">header</span>: <span class="hljs-string">'first'</span>,
      <span class="hljs-attr">badge</span>: <span class="hljs-number">12</span>,
      <span class="hljs-attr">content</span>: <span class="hljs-string">'first的内容'</span>
    }, {
      <span class="hljs-attr">header</span>: <span class="hljs-string">'seacond'</span>,
      <span class="hljs-attr">badge</span>: <span class="hljs-number">12</span>,
      <span class="hljs-attr">content</span>: <span class="hljs-string">'seacond的内容'</span>
    }]
  }
}
</code></pre>
<hr>
<blockquote>
<p>使用tab</p>
</blockquote>
<n3-tabs @change="change" :value="1">
  <n3-tab header="one" badge="1">
    <p>.......</p>
    <p>.......</p>
    <p>.......</p>
  </n3-tab>
  <n3-tab header="two">
    <p>*********</p>
    <p>*********</p>
    <p>*********</p>
  </n3-tab>
  <n3-tab header="three" disabled>
    ...
  </n3-tab>
</n3-tabs>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-tabs</span> <span class="hljs-attr">@change</span>=<span class="hljs-string">"change"</span> <span class="hljs-attr">:value</span>=<span class="hljs-string">"1"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-tab</span> <span class="hljs-attr">header</span>=<span class="hljs-string">"one"</span> <span class="hljs-attr">badge</span>=<span class="hljs-string">"1"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>.......<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>.......<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>.......<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-tab</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-tab</span> <span class="hljs-attr">header</span>=<span class="hljs-string">"two"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>*********<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>*********<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>*********<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-tab</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-tab</span> <span class="hljs-attr">header</span>=<span class="hljs-string">"three"</span> <span class="hljs-attr">disabled</span>&gt;</span>
    ...
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-tab</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-tabs</span>&gt;</span>
</code></pre>
<hr>
<blockquote>
<p>胶囊样式 pills</p>
</blockquote>
<n3-tabs pills="">
  <n3-tab header="one">
  </n3-tab>
  <n3-tab header="two">
  </n3-tab>
</n3-tabs>
<hr>
<blockquote>
<p>垂直样式 stacked</p>
</blockquote>
<n3-tabs pills="" stacked="" style="max-width: 300px;" @change="change">
  <n3-tab header="one">
  </n3-tab>
  <n3-tab header="two">
  </n3-tab>
</n3-tabs>
<hr>
<blockquote>
<p>垂直样式 stacked</p>
</blockquote>
<n3-tabs primary="" pills="" stacked="" style="max-width: 300px;">
  <n3-tab header="one">
  </n3-tab>
  <n3-tab header="two">
  </n3-tab>
</n3-tabs>
<hr>
<blockquote>
<p>自适应 justified</p>
</blockquote>
<n3-tabs pills="" justified="">
  <n3-tab header="one">
  </n3-tab>
  <n3-tab header="two">
  </n3-tab>
</n3-tabs>
</div>
<pre v-pre=""><code v-pre="" class="language-javascript"><span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data () {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">list</span>: [{
        <span class="hljs-attr">header</span>: <span class="hljs-string">'first'</span>,
        <span class="hljs-attr">badge</span>: <span class="hljs-number">12</span>,
        <span class="hljs-attr">content</span>: <span class="hljs-string">'first的内容'</span>
      }, {
        <span class="hljs-attr">header</span>: <span class="hljs-string">'seacond'</span>,
        <span class="hljs-attr">badge</span>: <span class="hljs-number">12</span>,
        <span class="hljs-attr">content</span>: <span class="hljs-string">'seacond的内容'</span>
      }]
    }
  },
  <span class="hljs-attr">methods</span>: {
    change (index, el) {
      <span class="hljs-built_in">console</span>.log(index, el)
    }
  }
}
</code></pre>
<h3>Tabs参数</h3>
<table>
<thead>
<tr>
<th>参数名</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>value</td>
<td><code v-pre="">Number</code></td>
<td></td>
<td></td>
</tr>
<tr>
<td>list</td>
<td><code v-pre="">Array</code></td>
<td></td>
<td></td>
</tr>
<tr>
<td>pills</td>
<td><code v-pre="">Boolean</code></td>
<td></td>
<td>胶囊样式</td>
</tr>
<tr>
<td>stacked</td>
<td><code v-pre="">Boolean</code></td>
<td>false</td>
<td>竖直状态</td>
</tr>
<tr>
<td>primary</td>
<td><code v-pre="">Boolean</code></td>
<td>false</td>
<td></td>
</tr>
<tr>
<td>justified</td>
<td><code v-pre="">Boolean</code></td>
<td>false</td>
<td>是否自适应</td>
</tr>
<tr>
<td>size</td>
<td><code v-pre="">String</code></td>
<td></td>
<td>尺寸</td>
</tr>
</tbody>
</table>
<h3>Tabs Events</h3>
<table>
<thead>
<tr>
<th>事件名称</th>
<th>说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>change</td>
<td>切换tab时</td>
<td></td>
</tr>
</tbody>
</table>
<h3>tab 参数</h3>
<table>
<thead>
<tr>
<th>参数名</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>header</td>
<td><code v-pre="">String</code></td>
<td></td>
<td>标签头文字</td>
</tr>
<tr>
<td>badge</td>
<td><code v-pre="">String``Number</code></td>
<td></td>
<td>徽标</td>
</tr>
<tr>
<td>disabled</td>
<td><code v-pre="">Boolean</code></td>
<td>false</td>
<td>是否能被激活</td>
</tr>
</tbody>
</table>
</div>
</template>

</section></template>

<script>
export default {
  data () {
    return {
      index:0,
      list: [{
        header: 'first',
        badge: 12,
        content: 'first的内容'
      }, {
        header: 'seacond',
        badge: 12,
        content: 'seacond的内容'
      }]
    }
  },
  methods: {
    change (index, el) {
      console.log(index, el)
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3TabsDocs.md?d5b9d656